import { defineFetch } from 'resift';

const makeGetSources = defineFetch({
  displayName: 'Get Sources',
  make: () => ({
    request: (sourceType: string) => ({ http }) =>
      http({
        method: 'GET',
        route: `/sources`,
        query: { type: sourceType },
      }),
  }),
});

const getSources = makeGetSources();

export default getSources;
